import init from '../../helpers/init';
import {showAlert} from '../main';

const {$} = init;
const BX = (<any>window).BX;

$(() => {
  $(document).on('click', '.js-hide-recommendation', (e) => {
    e.preventDefault();
    const userId = $(e.currentTarget).data('id');
    const component = $(e.currentTarget).data('c');
    const data = {
      userId
    };
    BX.ajax.runComponentAction(component, 'hideRecommendation', {
      data,
      mode: 'class'
    }).then((result: any) => {
      if (result.status === 'success') {
        $(`.js-recommendation[data-id=${userId}]`).html('<div class="js-site-preloader"></div>');
        if($('form.js-pjax-filter').length){
          $('form.js-pjax-filter').trigger('submit')
        }
      }
    })
      .catch((err: any) => {
        showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
        console.log(err);
      });
  });
});
